import httpClient from '@/utilities/service/httpClient'
import AbstractApi from '@/api/abstracts/AbstractApi'
import BidApi from '@/api/services/sales/bid/BidApi'
import AttachmentApi from '@/api/services/sales/attachment/AttachmentApi'
import DecisionApi from '@/api/services/sales/decision/DecisionApi'
import CommentApi from '@/api/services/sales/comment/CommentApi'
import ProjectApi from '@/api/services/sales/project/ProjectApi'
// eslint-disable-next-line prettier/prettier
import type { BidNumber } from '@/api/types/general/GeneralType'
import type { ChangeBidStatusPayloadType } from '@/api/types/request/ChangeBidStatusPayloadType'
import type { ChangeBidStatusType } from '@/api/types/response/ChangeBidStatusType'
import type { CloneSitePayloadType } from '@/api/types/request/SitePayloadType'
import type { CloneSiteType } from '@/api/types/response/SiteType'

/**
 * @property string apiEnd /api/sales
 */
export default class SalesApi extends AbstractApi {
  bid(): BidApi {
    return new BidApi(`${this.apiEnd}/bid`)
  }

  decision(): DecisionApi {
    return new DecisionApi(`${this.apiEnd}/decision`)
  }

  attachment(bidNumber: BidNumber): AttachmentApi {
    return new AttachmentApi(`${this.apiEnd}/attachment/${bidNumber}`)
  }

  comment(bidNumber: BidNumber): CommentApi {
    return new CommentApi(`${this.apiEnd}/comments/${bidNumber}`)
  }

  changeStatus(payload: ChangeBidStatusPayloadType): Promise<ChangeBidStatusType> {
    return httpClient.post(`${this.apiEnd}/status/add`, payload)
  }

  cloneSites(payload: CloneSitePayloadType): Promise<CloneSiteType> {
    return httpClient.post(`${this.apiEnd}/cloning/${payload.bidNumber}/sites`, payload)
  }

  project(): ProjectApi {
    return new ProjectApi(`${this.apiEnd}/project`)
  }
}
